var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorocco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_8297)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_8297",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_8297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H1V23H35.2819V3Z",
    fill: "#B01F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.775 11.3964H12.3625L17.391 15.233L18.1409 14.6572L15.0944 12.3338L16.4871 12.3271L16.775 11.3964Z",
    fill: "#2B6537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5069 11.3964L18.141 6.98392L16.2193 13.1908L16.9759 13.7666L18.141 10.0037L18.5762 11.3964H19.5069Z",
    fill: "#2B6537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3505 14.1282L23.9193 11.3964H17.7124L17.4178 12.3271H21.1874L20.0626 13.1908L20.3505 14.1282Z",
    fill: "#2B6537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1409 15.8155L21.7097 18.5407L19.7948 12.3271H18.8641L20.0224 16.0901L18.8975 15.233L18.1409 15.8155Z",
    fill: "#2B6537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9313 14.1215L14.5721 18.5407L19.5938 14.6974L19.3059 13.7667L16.2594 16.0968L16.6879 14.7041L15.9313 14.1215Z",
    fill: "#2B6537"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_8297",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_8297"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_8297",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorocco);
export default __webpack_public_path__ + "static/media/Morocco.9ff1f2c0361b098fa4ae4a4caad317e3.svg";
export { ForwardRef as ReactComponent };